import { render, staticRenderFns } from "./TradeAccountDetails.vue?vue&type=template&id=4fb70231&"
import script from "./TradeAccountDetails.vue?vue&type=script&lang=js&"
export * from "./TradeAccountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports